import React from 'react';
import PropTypes from 'prop-types';

export const ArrowIcon = ({ color = '#667485', ...props }) => (
  <svg viewBox="0 0 8 5" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M.5 4.5L4 .5l3.5 4"
      stroke={color}
      fill="none"
      fillRule="evenodd"
      opacity=".797"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowIcon.propTypes = {
  color: PropTypes.string
};
